import type { ReactNode } from 'react'
import { WorkflowProvider } from 'app/WorkflowProvider'
import { EntitlementProvider } from 'app/EntitlementProvider'
import { useUserCheck } from '@front/model'
import { SidebarNavigationProvider } from './SidebarNavigationContext'
import { ArchivedShell } from './ArchivedShell'
import { ActiveShell } from './ActiveShell'

export const LayoutWithoutAuth = ({
  children,
}: Readonly<{
  children: ReactNode
}>): ReactNode => {
  const { data: userCheck } = useUserCheck()

  if (userCheck?.canAccess === false) return <ArchivedShell result={userCheck} />
  return (
    <EntitlementProvider>
      <WorkflowProvider>
        <SidebarNavigationProvider>
          <ActiveShell>{children}</ActiveShell>
        </SidebarNavigationProvider>
      </WorkflowProvider>
    </EntitlementProvider>
  )
}
